module.exports = __webpack_public_path__ + "img/record.394df660.svg";